import { Modal, Text, Image, View, TouchableOpacity } from "react-native";
import React, { useMemo, useState } from "react";
import { StackActions, useNavigation } from "@react-navigation/native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppImages } from "../../../../utility/AppImages";
import { CommonButton } from "../../../../common/CommonButton";
import { ScrollView } from "react-native-gesture-handler";
import SuccessFullSignUpModal from "./SuccessFullSignUpModal";
import {
  createWatchingEvent,
  signUpEvent,
} from "../../../../services/eventsAPI";
import { toast } from "react-toastify";
import { handleApiError } from "../../../../services/errorHandler";
import { format } from "date-fns";
import Avatar from "../../../../Components/choose-avatar-components/Avatar";
import { fetchUserBalance } from "../../../../services/profileAPI";
import { useUserData } from "../../../../context/UserDataContext";
import { calculateStakesValue } from "../../../../utility/stakesCalculator";

export default function SignUpModal({
  closeSignUp,
  accessToken,
  item,
  userId,
  setIsSignUp,
}) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const { fetchUserProfile } = useUserData();
  const [modalVisible, setModalVisible] = useState(false);
  let strPressBtnType = "";
  const [updateShowLoader, setUpdateShowLoader] = useState(false);
  const date = useMemo(
    () => new Date(item?.eventStartTime),
    [item?.eventStartTime]
  );

  const formattedDate = item?.eventStartTime
    ? format(date, "dd/MM/yyyy HH:mm-HH:mm")
    : "No date available";

  const organizer =
    item?.participantDetails?.find(
      (participant) => participant.userID === item?.organiserId
    ) || {};

  const challenger =
    item?.participantDetails?.find(
      (participant) => participant.userID !== item?.organiserId
    ) || {};

  const stakes = item?.stakes || [];
  const availableStakes = stakes.filter((stake) => stake.quantity > 0);

  const { totalCredits, totalValue } = calculateStakesValue(stakes);

  const callSignUpEventAPI = async () => {
    setUpdateShowLoader(true);

    const bodyParams = {
      accessToken: accessToken,
      eventID: item.eventID,
      newAttendeeIDs: [userId],
    };

    try {
      const response = await signUpEvent(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          toast.success(response.body.message);

          // Refresh profile and balance to update token display in header
          try {
            await Promise.all([
              fetchUserProfile(accessToken),
              fetchUserBalance(accessToken),
            ]);
          } catch (refreshError) {
            console.error("Error refreshing profile/balance:", refreshError);
          }

          setModalVisible(true);
          // callWatchingEventAPI();

          setUpdateShowLoader(false);
        }
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      setUpdateShowLoader(false);
      toast.success(error.message);
    }
  };
  const callWatchingEventAPI = async () => {
    setUpdateShowLoader(true);
    const bodyParams = {
      accessToken: accessToken,
      eventId: item.eventID,
    };
    try {
      const response = await createWatchingEvent(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          setModalVisible(true);
          setUpdateShowLoader(false);
        }
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      setUpdateShowLoader(false);
      toast.error(error.message);
    }
  };
  return (
    <Modal transparent={true} visible={true} animationType="slide">
      <View style={styles.container}>
        <View style={styles.mainView}>
          {/* Header */}
          <View style={styles.headerContainer}>
            <Text style={styles.headerTitle}>Sign-Up to watch event</Text>
            <TouchableOpacity
              onPress={() => setIsSignUp(false)}
              style={styles.closeButton}
            >
              <Image
                source={AppImages.icCancel}
                style={styles.closeIcon}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>

          <ScrollView
            showsVerticalScrollIndicator={false}
            style={{ backgroundColor: "transparent", borderWidth: 0 }}
            contentContainerStyle={styles.scrollContent}
          >
            {/* VS Section */}
            <View style={styles.vsSection}>
              <View style={styles.playersRow}>
                <View style={styles.playerColumn}>
                  <Text style={styles.kallerLabel}>Kaller</Text>
                  <View style={styles.playerCard}>
                    <Avatar
                      src={organizer?.profilePicture}
                      variant="OnGoingPlayerDetail"
                    />
                    <Text style={styles.playerName}>
                      {organizer?.userID || "Joseb"}
                    </Text>
                  </View>
                </View>

                <View style={styles.middleSection}>
                  <Image
                    source={AppImages.icVsLogo}
                    style={styles.vsIcon}
                    resizeMode="contain"
                  />
                  {(deviceSize === DEVICE_SIZES.LG ||
                    deviceSize === DEVICE_SIZES.XL ||
                    deviceSize === DEVICE_SIZES.MD) && (
                      <>
                        <Text style={styles.challengeText}>
                          {organizer?.userID || "Alex"} has challenged{" "}
                          {challenger?.userID || "Jacob"}
                        </Text>
                        <View style={styles.eventTimeWrapper}>
                          <Text style={styles.eventTimeLabel}>
                            Will start on:
                          </Text>
                          <View style={styles.eventTimeContainer}>
                            <Text style={styles.eventTime}>{formattedDate}</Text>
                          </View>
                        </View>
                      </>
                    )}
                </View>

                <View style={styles.playerColumn}>
                  <Text style={styles.challengerLabel}>Opponent</Text>
                  <View style={styles.playerCard}>
                    <Avatar
                      src={challenger?.profilePicture}
                      variant="OnGoingPlayerDetail"
                    />
                    <Text style={styles.playerName}>
                      {challenger?.userID || "Joseb"}
                    </Text>
                  </View>
                </View>
              </View>

              {/* Mobile text section - shown only on XS and SM */}
              {(deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM) && (
                  <View style={styles.mobileTextSection}>
                    <Text style={styles.challengeText}>
                      {organizer?.userID || "Alex"} has challenged{" "}
                      {challenger?.userID || "Jacob"}
                    </Text>
                    <View style={styles.eventTimeWrapper}>
                      <Text style={styles.eventTimeLabel}>Will start on:</Text>
                      <View style={styles.eventTimeContainer}>
                        <Text style={styles.eventTime}>{formattedDate}</Text>
                      </View>
                    </View>
                  </View>
                )}
            </View>

            {/* Challenge Reward Section */}
            <View style={styles.combinedSection}>
              {/* Section Title */}
              <Text style={styles.sectionTitle}>Challenge Reward</Text>

              {/* Main Horizontal Row */}
              <View style={styles.mainRow}>
                {/* Left Column: Belts + Worth Section */}
                <View style={styles.leftColumn}>
                  {/* Belts Section */}
                  {availableStakes.length > 0 && (
                    <View style={styles.beltsContainer}>
                      {availableStakes.map((stake, index) => {
                        const getBeltIcon = (type) => {
                          switch (type.toLowerCase()) {
                            case "gold":
                              return AppImages.icGoldBelt;
                            case "silver":
                              return AppImages.icSilverBelt;
                            case "bronze":
                              return AppImages.icBronzeBelt;
                            case "platinum":
                              return AppImages.icPlatinumBelt;
                            case "coin":
                              return AppImages.icCoinBelt;
                            default:
                              return AppImages.icBronzeBelt;
                          }
                        };

                        return (
                          <View key={index} style={styles.beltItem}>
                            <Image
                              source={getBeltIcon(stake.type)}
                              style={styles.beltIcon}
                              resizeMode="contain"
                            />
                            <Text style={styles.beltCount}>
                              {stake.quantity}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                  )}

                  <View style={styles.worthSection}>
                    <View style={styles.worthValueRow}>
                      <Text style={styles.creditsText}>
                        {totalCredits} Credits worth
                      </Text>
                      <View style={styles.valueContainer}>
                        <Text style={styles.valueAmount}>
                          £{totalValue.toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>

                {/* Right Column: Game Section */}
                <View style={styles.gameSection}>
                  <Image
                    source={{ uri: item?.gameImage }}
                    style={styles.gameIcon}
                    resizeMode="cover"
                  />
                  <Text style={styles.gameLabel}>
                    {item?.gameTitle || "Game"}
                  </Text>
                </View>
              </View>
            </View>

            {/* Sign Up Section */}
            <View style={styles.signUpSection}>
              <Text style={styles.signUpTitle}>Sign up now</Text>
              <Text style={styles.signUpDescription}>
                Sign up for the event to watch the competitive streaming. Chat
                with fans and send gifts to your favourite players.
              </Text>
            </View>
          </ScrollView>

          {/* Action Buttons */}
          <View style={styles.buttonContainer}>
            <TouchableOpacity
              onPress={() => setIsSignUp(false)}
              style={styles.closeButtonAction}
            >
              <Text style={styles.closeButtonText}>Close</Text>
            </TouchableOpacity>
            <CommonButton
              title={updateShowLoader ? "Signing up..." : "Sign up"}
              onTap={async () => {
                await callSignUpEventAPI();
              }}
              disabled={updateShowLoader}
              buttonStyle={styles.signUpButton}
              textStyle={styles.signUpButtonText}
            />
          </View>
        </View>
      </View>

      {modalVisible && (
        <SuccessFullSignUpModal
          item={item}
          openSuccessSignUpModal={modalVisible}
          closeSignUpModal={closeSignUp}
          closeSuccessSignUpModal={() => {
            setModalVisible(false);
          }}
        />
      )}
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      borderRadius: 8,
      borderWidth: 1.6,
      borderColor: "rgba(239, 68, 68, 0.50)",
      backgroundColor: "#111827",
      width: "90%",
      maxWidth: 650,
      maxHeight: "90%",
    },
    headerContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 20,
      paddingBottom: 10,
    },
    headerTitle: {
      ...AppFontStyle.BOLD_ANYBODY_20,
      color: AppColors.white,
    },
    closeButton: {
      backgroundColor: "rgba(75, 85, 99, 0.5)",
      width: 32,
      height: 32,
      borderRadius: 16,
      justifyContent: "center",
      alignItems: "center",
    },
    closeIcon: {
      width: 16,
      height: 16,
      tintColor: AppColors.white,
    },
    scrollContent: {
      paddingHorizontal: 20,
      paddingBottom: 20,
    },
    vsSection: {
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      backgroundColor: "rgba(31, 41, 55, 0.50)", // Approximating the gradient
      padding: 16,
      flexDirection: "column",
      marginBottom: 16,
    },
    playersRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: 12,
    },
    playerColumn: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 5,
      maxWidth: 160,
      minWidth: 140,
    },
    kallerLabel: {
      ...AppFontStyle.BOLD_ANYBODY_16,
      color: "#DC2626",
      lineHeight: 18.48,
    },
    challengerLabel: {
      ...AppFontStyle.BOLD_ANYBODY_16,
      color: "#DC2626",
      lineHeight: 18.48,
    },
    playerCard: {
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      background:
        "linear-gradient(135deg, rgba(31, 41, 55, 0.50) 0%, rgba(17, 24, 39, 0.50) 100%)",
      backgroundColor: "rgba(31, 41, 55, 0.50)",
      padding: 10,
      alignItems: "center",
      width: "100%",
      gap: 6,
    },
    playerName: {
      ...AppFontStyle.BOLD_ANYBODY_14,
      color: AppColors.white,
    },
    middleSection: {
      flexDirection: "column",
      alignItems: "center",
      gap: 10,
      flex: 1,
      justifyContent: "center",
    },
    vsIcon: {
      width: 80,
      height: 80,
    },
    challengeText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
      textAlign: "center",
      marginBottom: 8,
    },
    eventTimeWrapper: {
      flexDirection: "column",
      alignItems: "center",
    },
    eventTimeLabel: {
      ...AppFontStyle.REGULAR_ANYBODY_12,
      color: AppColors.gray_C3C3C3,
      marginBottom: 4,
    },
    eventTimeContainer: {
      backgroundColor: "#A3881D",
      borderRadius: 8.74,
      paddingHorizontal: 12,
      paddingVertical: 6,
    },
    eventTime: {
      ...AppFontStyle.BOLD_ANYBODY_12,
      color: AppColors.white,
    },
    mobileTextSection: {
      display: "none",
    },
    combinedSection: {
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      backgroundColor: "rgba(31, 41, 55, 0.50)",
      padding: 16,
      marginBottom: 8,
    },
    sectionTitle: {
      ...AppFontStyle.BOLD_ANYBODY_16,
      color: AppColors.white,
      marginBottom: 16,
    },
    mainRow: {
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
    },
    leftColumn: {
      flex: 2,
      flexDirection: "column",
      gap: 16,
    },
    beltsContainer: {
      flexDirection: "row",
      gap: 12,
      justifyContent: "center",
    },
    beltItem: {
      alignItems: "center",
      flexDirection: "column",
      gap: 8,
    },
    beltIcon: {
      width: 80,
      height: 80,
    },
    beltCount: {
      ...AppFontStyle.BOLD_ANYBODY_16,
      color: AppColors.white,
      backgroundColor: "#1F2937",
      borderRadius: 12,
      borderWidth: 1,
      borderColor: "#374151",
      paddingHorizontal: 12,
      paddingVertical: 6,
      minWidth: 32,
      textAlign: "center",
    },
    worthSection: {
      alignItems: "center",
    },
    worthValueRow: {
      flexDirection: "row",
      alignItems: "center",
      gap: 12,
      marginTop: 8,
    },
    acceptText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
      textAlign: "center",
    },
    creditsText: {
      ...AppFontStyle.BOLD_ANYBODY_14,
      color: AppColors.white,
      textAlign: "center",
    },
    valueContainer: {
      backgroundColor: "#1F2937",
      borderRadius: 8,
      borderWidth: 1,
      borderColor: "#374151",
      paddingHorizontal: 12,
      paddingVertical: 8,
    },
    valueAmount: {
      ...AppFontStyle.BOLD_ANYBODY_16,
      color: AppColors.white,
    },
    gameSection: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    gameIcon: {
      width: 138,
      height: 152,
      borderRadius: 8,
      marginBottom: 8,
    },
    gameLabel: {
      ...AppFontStyle.BOLD_ANYBODY_12,
      color: AppColors.white,
      textAlign: "center",
      maxWidth: 150,
      marginTop: 4,
    },
    signUpSection: {
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      backgroundColor: "rgba(31, 41, 55, 0.50)",
      padding: 16,
      marginBottom: 8,
    },
    signUpTitle: {
      ...AppFontStyle.BOLD_ANYBODY_16,
      color: AppColors.white,
      marginBottom: 8,
    },
    signUpDescription: {
      ...AppFontStyle.REGULAR_ANYBODY_12,
      color: AppColors.gray_C3C3C3,
      lineHeight: 18,
    },
    buttonContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 20,
      paddingTop: 0,
      marginTop: 20,
    },
    closeButtonAction: {
      backgroundColor: "transparent",
      borderWidth: 1,
      borderColor: AppColors.gray_C3C3C3,
      borderRadius: 8,
      height: 40,
      paddingVertical: 10,
      paddingHorizontal: 24,
      minWidth: 100,
      alignItems: "center",
      justifyContent: "center",
    },
    closeButtonText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
    },
    signUpButton: {
      borderRadius: 6,
      backgroundColor: "#DC2626", // Linear gradient approximation from #DC2626 to #991B1B
      height: 40,
      paddingVertical: 10,
      paddingHorizontal: 24,
      justifyContent: "center",
      alignItems: "center",
      shadowOpacity: 0,
      minWidth: 100,
    },
    signUpButtonText: {
      ...AppFontStyle.BOLD_ANYBODY_14,
      color: AppColors.white,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        justifyContent: "flex-end",
        alignItems: "stretch",
      },
      mainView: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: "80%",
        borderRadius: 0,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomWidth: 0,
      },
      buttonContainer: {
        borderTopWidth: 1,
        borderTopColor: "#374151",
        paddingTop: 16,
        marginTop: 0,
        paddingBottom: 20,
      },
      headerContainer: {
        padding: 16,
        paddingBottom: 8,
      },
      headerTitle: {
        ...AppFontStyle.BOLD_ANYBODY_16,
      },
      scrollContent: {
        paddingHorizontal: 16,
      },
      vsSection: {
        padding: 12,
      },
      playersRow: {
        flexDirection: "row",
        gap: 8,
        alignItems: "flex-start",
        justifyContent: "space-between",
      },
      playerColumn: {
        flex: 1,
        maxWidth: "30%",
        minWidth: 90,
      },
      kallerLabel: {
        color: "#DC2626",
        fontSize: 12,
        fontWeight: "700",
        lineHeight: 13.86,
        marginBottom: 6,
      },
      challengerLabel: {
        color: "#DC2626",
        fontSize: 12,
        fontWeight: "700",
        lineHeight: 13.86,
        marginBottom: 6,
      },
      playerCard: {
        padding: 8,
        minHeight: 120,
        justifyContent: "center",
      },
      playerName: {
        ...AppFontStyle.BOLD_ANYBODY_11,
        textAlign: "center",
      },
      middleSection: {
        gap: 6,
        flex: 1,
        minWidth: 80,
        maxWidth: 90,
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120,
      },
      vsIcon: {
        width: 63.861,
        height: 144,
        marginTop: 15,
      },
      mobileTextSection: {
        marginTop: 16,
        gap: 10,
        alignItems: "center",
        width: "100%",
        display: "flex",
      },
      challengeText: {
        ...AppFontStyle.REGULAR_ANYBODY_13,
        textAlign: "center",
      },
      eventTimeWrapper: {
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      },
      eventTimeLabel: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
        marginBottom: 6,
      },
      eventTimeContainer: {
        paddingHorizontal: 16,
        paddingVertical: 8,
      },
      eventTime: {
        ...AppFontStyle.BOLD_ANYBODY_12,
      },
      mainRow: {
        flexDirection: "row",
        gap: 12,
        alignItems: "flex-start",
        justifyContent: "space-between",
      },
      leftColumn: {
        gap: 12,
        alignItems: "center",
        flex: 1,
      },
      beltsContainer: {
        justifyContent: "center",
        gap: 8,
        flexWrap: "wrap",
      },
      beltItem: {
        gap: 4,
      },
      beltIcon: {
        width: 50,
        height: 50,
      },
      beltCount: {
        ...AppFontStyle.BOLD_ANYBODY_14,
        paddingHorizontal: 8,
        paddingVertical: 4,
        minWidth: 28,
      },
      worthValueRow: {
        flexDirection: "column",
        gap: 8,
        alignItems: "center",
      },
      gameSection: {
        flex: 0,
        alignItems: "center",
        justifyContent: "center",
        minWidth: 120,
      },
      acceptText: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
        textAlign: "center",
      },
      creditsText: {
        ...AppFontStyle.BOLD_ANYBODY_12,
        textAlign: "center",
      },
      valueAmount: {
        ...AppFontStyle.BOLD_ANYBODY_14,
      },
      gameIcon: {
        width: 100,
        height: 110,
      },
      gameLabel: {
        ...AppFontStyle.BOLD_ANYBODY_11,
        maxWidth: 120,
      },
      closeButtonAction: {
        minWidth: 90,
        paddingHorizontal: 20,
        height: 36,
        paddingVertical: 8,
      },
      signUpButton: {
        minWidth: 90,
        paddingHorizontal: 20,
        height: 36,
        paddingVertical: 8,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        justifyContent: "flex-end",
        alignItems: "stretch",
      },
      mainView: {
        width: "100%",
        maxWidth: "100%",
        maxHeight: "80%",
        borderRadius: 0,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomWidth: 0,
      },
      buttonContainer: {
        borderTopWidth: 1,
        borderTopColor: "#374151",
        paddingTop: 16,
        marginTop: 0,
        paddingBottom: 20,
      },
      headerTitle: {
        ...AppFontStyle.BOLD_ANYBODY_18,
      },
      vsSection: {
        padding: 14,
      },
      playersRow: {
        flexDirection: "row",
        gap: 10,
        alignItems: "flex-start",
        justifyContent: "space-between",
      },
      playerColumn: {
        flex: 1,
        maxWidth: "30%",
        minWidth: 100,
      },
      kallerLabel: {
        color: "#DC2626",
        fontSize: 12,
        fontWeight: "700",
        lineHeight: 13.86,
        marginBottom: 6,
      },
      challengerLabel: {
        color: "#DC2626",
        fontSize: 12,
        fontWeight: "700",
        lineHeight: 13.86,
        marginBottom: 6,
      },
      playerCard: {
        padding: 10,
        minHeight: 130,
        justifyContent: "center",
      },
      playerName: {
        ...AppFontStyle.BOLD_ANYBODY_12,
        textAlign: "center",
      },
      middleSection: {
        gap: 6,
        flex: 1,
        minWidth: 80,
        maxWidth: 90,
        justifyContent: "center",
        alignItems: "center",
        minHeight: 130,
      },
      vsIcon: {
        width: 63.861,
        height: 144,
        marginTop: 15,
      },
      mobileTextSection: {
        marginTop: 16,
        gap: 10,
        alignItems: "center",
        width: "100%",
        display: "flex",
      },
      challengeText: {
        ...AppFontStyle.REGULAR_ANYBODY_13,
        textAlign: "center",
      },
      eventTimeWrapper: {
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      },
      eventTimeLabel: {
        ...AppFontStyle.REGULAR_ANYBODY_12,
        marginBottom: 6,
      },
      eventTimeContainer: {
        paddingHorizontal: 16,
        paddingVertical: 8,
      },
      eventTime: {
        ...AppFontStyle.BOLD_ANYBODY_12,
      },
      closeButtonAction: {
        minWidth: 95,
        height: 38,
        paddingVertical: 9,
      },
      signUpButton: {
        minWidth: 95,
        height: 38,
        paddingVertical: 9,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainView: {
        width: "80%",
        maxWidth: 600,
      },
    },
    [DEVICE_SIZES.LG]: {
      mainView: {
        width: "70%",
        maxWidth: 650,
      },
    },
  }
);
